import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
interface LogoProps {
  variant?: 'full' | 'wordmark' | 'mark';
  className?: string;
  markClassName?: string;
}
export function Logo({
  variant = 'full',
  className = '',
  markClassName = ''
}: LogoProps) {
  const {
    brand
  } = useBrand();
  const isUpper = brand.wordmarkCase === 'upper';
  return <span className={`inline-flex items-center gap-3 ${className}`} data-id="element-29" data-mp="1rpe0dvqti7sv">
      {variant !== 'wordmark' && <Mark className={markClassName} data-id="element-30" data-mp="u1ngaxgom8fs" />}
      {variant !== 'mark' && <span className={`font-serif text-[1.35em] leading-none ${isUpper ? 'tracking-wordmark' : 'tracking-tight'}`} data-id="element-31" data-mp="yzf8ztp5hyl1">
          {brand.wordmark}
        </span>}
      <span className="sr-only" data-id="element-32" data-mp="18yeh9b607s7i">{brand.name}</span>
    </span>;
}
export function Mark({
  className = ''
}: {
  className?: string;
}) {
  const {
    brand
  } = useBrand();
  if (brand.mark === 'leaf') {
    return <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-[1.15em] w-[1.15em] shrink-0 ${className}`} fill="none" data-id="element-33" data-mp="2ke35e5uzux9w">
        {/* Two mirrored arcs meeting at the tips — a leaf drawn from a single stroke weight. */}
        <path d="M4 20C4 11.7157 10.7157 5 19 5C19 13.2843 12.2843 20 4 20Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" data-id="element-34" data-mp="1nvspqoub4760" />
        <path d="M4 20L14.5 9.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" data-id="element-35" data-mp="1dyxs085uyass" />
      </svg>;
  }
  return <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-[1.1em] w-[1.1em] shrink-0 ${className}`} fill="none" data-id="element-36" data-mp="196efzfmtjnq3">
      <circle cx="12" cy="12" r="9.4" stroke="currentColor" strokeWidth="1.6" strokeDasharray="25.5 4 25.5 4" transform="rotate(-42 12 12)" data-id="element-37" data-mp="1079f42nsbiar" />
    </svg>;
}